"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Variables_1 = require("../Variables");
var Close_1 = __importDefault(require("../Icon/icons/Close"));
var ChevronLeft_1 = __importDefault(require("../Icon/icons/ChevronLeft"));
var MobileMenuHeaderWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: center;\n"], ["\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: center;\n"])), Variables_1.color.BRAND_PREMIUM_GREY);
var MobileMenuHeaderTitle = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-grow: 1;\n  text-align: center;\n  padding: ", ";\n"], ["\n  flex-grow: 1;\n  text-align: center;\n  padding: ", ";\n"])), Variables_1.padding.MD);
var MobileMenuItemNav = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  display: flex;\n  flex-shrink: 0;\n  height: 40px;\n  justify-content: center;\n  width: 40px;\n"], ["\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  display: flex;\n  flex-shrink: 0;\n  height: 40px;\n  justify-content: center;\n  width: 40px;\n"])));
var MobileMenuHeader = function (_a) {
    var className = _a.className, color = _a.color, onBackClick = _a.onBackClick, onCloseClick = _a.onCloseClick, title = _a.title;
    return (React.createElement(MobileMenuHeaderWrapper, { className: className },
        React.createElement(MobileMenuItemNav, { onClick: onBackClick }, onBackClick && React.createElement(ChevronLeft_1.default, { color: color })),
        React.createElement(MobileMenuHeaderTitle, null, title),
        React.createElement(MobileMenuItemNav, { onClick: onCloseClick }, onCloseClick && React.createElement(Close_1.default, { color: color }))));
};
exports.default = MobileMenuHeader;
var templateObject_1, templateObject_2, templateObject_3;
